import BaseExtendedListViewController from '../../base/controllers/extended-list-view';
import customKomsaTemplate from '../views/extended-overview-customs/komsa.tpl.html';
import customMbdaTemplate from '../views/extended-overview-customs/mbda.tpl.html';
import airportPaybackTemplate from '../views/extended-overview-customs/airport-payback.tpl.html';
import oktoberfestTemplate from '../views/extended-overview-customs/oktoberfest.tpl.html';

import RsvpQuickEditController from '../../../pages/guestlists/components/extended-info/quick-edit-controller';
import RsvpQuickEditCustomController
    from '../../../pages/guestlists/components/extended-info/quick-edit-custom-controller';
import quickEditModalTemplate
    from './../../../pages/guestlists/workflows/heart-me/rsvps-create-a-contact-and-add-rsvp.tpl.html';
import quickEditCustomModalTemplate from "./../../../pages/guestlists/workflows/heart-me/rsvps-quick-add.tpl.html";

import rsvpQrCodeModalTemplate from '../views/qr-code-modal.tpl.html';
import QrCodeController from './qr-code-controller';

import checkInRsvpTemplate from '../../../components/modals/checkin-modal/template.tpl.html';
import CheckInModalController from '../../../components/modals/checkin-modal/controller';
import moment from '../../action_log/controllers/extended-list-controller';
import askToArchiveRsvp from "../helpers/ask-to-archive-rsvp";
import rsvpSingleMessageModalCreator from '../../../modules/messages/helpers/rsvp-single-message-modal-creator';

export default class RsvpsExtendedListViewCtrl extends BaseExtendedListViewController {
    constructor(model, $injector, $scope) {
        super(model, $injector, $scope);
        this.modal = $injector.get('$uibModal');
        this.rootScope = $injector.get('$rootScope');
        this.resourceSelect = $injector.get('ResourceSelect');
        this.alert = $injector.get('Alert');
        this.sanitize = $injector.get('$sanitize');
        this.filter = $injector.get('$filter');
        this.rsvpStatusEmailHelper = this.injector.get('RsvpsStatusEmailHelper');

        this.parameters = {
            include: 'lastMessage,contact,guestlist,contact.categories,parent,parent.contact,representativeOf,representativeOf.contact,representative,representative.contact,recommendedBy,recommendedBy.contact'
        };
        this.depositService = $injector.get('Deposit');
        this.latestChangeInformation = null;
        this.fields = [];
        this.customFields = false;

        this.deposits = {
            rsvpStates: {}
        };

        this.setupContactSpecialViews();
        this.setupRsvpSpecialViews();
        this.initWatcher();
        this._loadDeposits();
    }

    _loadDeposits() {
        this.depositService.getRemoteDeposit('rsvps', 'states', []).then((value) => {
            this.deposits.rsvpStates = value;
        });
    }

    _reloadAllData() {
        if (this.store) {
            this.store.dispatch('getData');
            this.store.commit('setRefresh', true);
        }
    }

    initWatcher() {
        this.scope.$watch(() => {
            return this.store.state.data;
        }, () => {
            if (!this.loading) {
                this.loadData()
            }
        });
    }

    loadData() {
        return super.loadData().then(() => {
            this.updateAvailableViews();
            this.contact = this.model.contact.data;
            this.guestlist = this.model.guestlist.data;
            this.customQuickEdit = _.get(this.injector.get('Users'), 'state.company.settings.rsvps.reduced_quick_edit_guest');
            this.latestChangeInformation = this._prepareLatestChangeInformation(this.model.last_change);
            this.fields = [];
            if (_.get(this.injector.get('Users'), 'state.company.settings.rsvps.custom_field_order')) {
                this.setupCustomFields();
                this.customFields = true;
            }
        });
    }

    setupCustomFields() {
        this.model.guestlist.data.settings.enabled_fields.forEach(function (field) {
            let keys = field.split('.');
            let formatedField = this.model.guestlist.data.enabled_fields[keys[0]][keys[1]];
            if (formatedField.type === 'bool') {
                formatedField.type = 'boolean';
            }
            if (formatedField.type === 'string') {
                formatedField.type = formatedField.multiline ? 'textarea' : 'textbox';
                if (formatedField.enum) {
                    formatedField.type = 'select';
                    formatedField.name = formatedField.label;
                    if (formatedField.name === 'Sex') {
                        formatedField.enum = Object.values(formatedField.enum).map(o => o.toLowerCase());
                    } else {
                        formatedField.enum = Object.values(formatedField.enum);
                    }
                }
            }
            if (formatedField.type === 'image') {
                formatedField.type = 'media_image';
            }
            if (formatedField.type === 'file') {
                formatedField.type = 'media_file';
            }
            if (formatedField.type === 'color-codes') {
                formatedField.type = 'color_code_select';
                formatedField.enum = Object.values(formatedField.enum);
            }
            if (formatedField.type === 'float') {
                formatedField.type = 'decimal';
            }

            formatedField.name = formatedField.label;
            this.fields.push(
                {...formatedField, key: keys[1], parent: keys[0]}
            );
        }.bind(this));
    }

    updateAvailableViews() {
        this.availableViews = [
            {
                key: 'overview',
                label: 'Overview'
            },
            {
                key: 'booking',
                label: 'Booking'
            }
        ];

        if (this.acl.hasRight('messages::view') && this.acl.hasRight('messages::list')) {
            this.availableViews.push({
                key: 'messages',
                label: 'Messages'
            });
        }

        if (this.model.guestlist.data.settings.enable_guests) {
            this.availableViews.push({
                key: 'guests',
                label: 'Companions'
            });
        }

        if (_.get(this.model, 'guestlist.data.rsvp_relation_types', []).length > 0) {
            this.availableViews.push({
                key: 'relations',
                label: 'Related RSVPs'
            });
        }

        if (this.acl.hasModule('bookable_objects') && this.model.booked_objects.length > 0) {
            this.availableViews.push({
                key: 'booked_objects',
                label: 'Booked Objects'
            });
        }
    }

    sendEmail() {
        rsvpSingleMessageModalCreator(this.injector, this.model, this.contact, {
            guestlist: this.guestlist
        }).finally(() => {
            this.loadData()
        });
    }

    viewRsvp() {
        this.state.go('app.guestlists.rsvps.details.overview', {
            gid: this.model.guestlist_id,
            id: this.model.id,
            rsvp: this.model,
            store: this.store,
            back: this.state.current.name,
            backParams: this.params
        });
    }

    viewContact() {
        this.state.go('app.contacts.details.overview', {
            id: this.model.contact_id,
            // store: this.store,
            back: this.state.current.name,
            backParams: this.params
        });
    }

    changeRsvpStatus() {
        this.rsvpStatusEmailHelper.startFlow(this.model, _.get(this.model, 'contact.data'), _.get(this.model, 'guestlist.data')).then(() => {
            this._reloadAllData();
        }, () => {
            this._reloadAllData();
        });
    }

    editRsvp() {
        this.state.go('app.guestlists.rsvps.details.edit', {
            gid: this.model.guestlist_id,
            id: this.model.id,
            rsvp: this.model,
            store: this.store,
            back: this.state.current.name,
            backParams: this.params
        });
    }

    quickEditRsvp() {
        this.modal.open({
            templateUrl: quickEditModalTemplate,
            controllerAs: 'vm',
            controller: RsvpQuickEditController,
            size: 'md',
            resolve: {
                rsvpId: () => {
                    return this.model.id;
                }
            }
        }).result.then(() => {
            this.alert.success('Success', 'Changes have been saved');
            if (this.store) {
                this.store.dispatch('getData');
            }
        }, () => {
            this.loadData();
        });
    }

    quickEditCustomRsvp() {

        this.modal.open({
            templateUrl: quickEditCustomModalTemplate,
            controllerAs: 'vm',
            controller: RsvpQuickEditCustomController,
            size: 'md',
            resolve: {
                // guestlistInformation: () => {
                //     return this.loadGuestlistInformation(this.model.guestlist_id).then((guestlistInformation) => {
                //         return guestlistInformation;
                //     }, (e) => {
                //         this.error.default(e);
                //     })
                // },
                rsvpId: () => {
                    return this.model.id;
                }
            }
        }).result.then(() => {
            this.alert.success('Success', 'Changes have been saved');
            if (this.store) {
                this.store.dispatch('getData');
            }
        }, () => {
            this.loadData();
        });
    }

    // loadGuestlistInformation(guestlistId) {
    //     return this.api.get(`guestlists/${guestlistId}`).then((response) => {
    //         return response.data.data;
    //     }, (e) => {
    //         return e;
    //     })
    // }

    confirmNDeleteRsvp() {

        askToArchiveRsvp(this.model, this.injector).then(
            () => {
                if (this.store) {
                    this.store.dispatch('getData');
                    this.store.commit('setRefresh', true);
                }
            }
        );
    }

    getObjectVar(object, path) {
        return _.get(object, path);
    }

    prepareLabelForField(field) {
        if (field.label) {
            return field.label;
        }

        let label = field.slug.replace('.', ' ') + '';

        if (label.length > 0) {
            label = label.charAt(0).toUpperCase() + label.slice(1);
        }

        return label;
    }

    setupContactSpecialViews() {
        this.contactSpecialViews = {

        };
        this.specialContactView = null;

        const settingSpecialView = _.get(this.rootScope.user, 'company.data.settings.companies.special_views.contact-preview');
        if (settingSpecialView
            && Object.keys(this.contactSpecialViews).indexOf(settingSpecialView) !== -1) {
            this.specialContactView = this.contactSpecialViews[settingSpecialView];
        }
    }

    setupRsvpSpecialViews() {
        this.specialRsvpViews = {
            komsa: customKomsaTemplate,
            mbda: customMbdaTemplate,
            'airport-payback': airportPaybackTemplate,
            'oktoberfest': oktoberfestTemplate
        };
        this.specialRsvpView = null;

        const settingSpecialView = _.get(this.rootScope.user, 'company.data.settings.companies.special_views.rsvp-preview-overview');
        if (settingSpecialView
            && Object.keys(this.specialRsvpViews).indexOf(settingSpecialView) !== -1) {
            this.specialRsvpView = this.specialRsvpViews[settingSpecialView];
        }
    }

    quickAddGuest() {
        const action = this.injector.get('quickAddContact');

        action.action({}, {
            dispatch: () => {
                this.loadData();
            },
            state: {
                permanentFilters: {
                    guestlist_id: this.model.guestlist_id,
                    parent_rsvp_id: this.model.id
                }
            }
        });
    }

    showRsvpQrCode() {
        this.modal.open({
            controller: QrCodeController,
            controllerAs: 'vm',
            templateUrl: rsvpQrCodeModalTemplate,
            size: 'sm',
            resolve: {
                code: () => {
                    return this.model.code;
                }
            }
        }).result.then(() => {

        }, () => {

        });
    }

    checkInRsvp() {
        this.modal.open({
            templateUrl: checkInRsvpTemplate,
            controllerAs: 'vm',
            size: 'sm',
            controller: CheckInModalController,
            resolve: {
                rsvp: () => {
                    return this.model;
                }
            }
        }).result.then(pax_actual => {
            this.api.post(`rsvps/${this.model.id}/checkin`, {pax_actual}).then(() => {
                this.alert.success('Success', 'Update successful');
                // this.loadData();
                if (this.store) {
                    this.store.dispatch('getData');
                    this.store.commit('setRefresh', true);
                }
            }, response => this.alert.handle(response));
        }, response => this.alert.handle(response));
    }

    _prepareLatestChangeInformation(latestChange) {
        if (!latestChange) {
            return null;
        }

        const firstField = latestChange.fields[_.first(Object.keys(latestChange.fields))];

        return firstField ? {
            timestamp: latestChange.timestamp,
            firstField: {
                label: firstField.label,
                mode: firstField.mode,
                values: this._prepareChangeValuesForType(firstField.values, firstField.type)
            },
            moreChangesCount: Object.keys(latestChange.fields).length - 1
        } : null;
    }


    _prepareChangeValuesForType(values, type) {
        const out = {};

        _.each(values, (originalValue, key) => {
            let value;
            switch (type) {
                case 'bool':
                    value = originalValue ? this.translate.instant('general.verbs.yes') : this.translate.instant('general.verbs.no');
                    break;
                case 'date':
                    value = moment(originalValue).format('D.M.Y');
                    break;
                case 'datetime':
                    value = moment(originalValue).format('Y-M-D HH:mm:ss');
                    break;
                case 'string':
                    value = this.sanitize(originalValue + '');
                    break;
                case 'integer':
                    value = parseInt(originalValue);
                    break;
                case 'float':
                    value = parseFloat(originalValue);
                    break;
                default:
                    console.info('No transformer for type "' + type + '" defined');
                    value = this.sanitize(originalValue);
            }

            out[key] = value;
        });

        return out;
    }

    goToChangelog() {
        this.state.go('app.guestlists.rsvps.details.changelog', {
            gid: this.model.guestlist_id,
            id: this.model.id,
            rsvp: this.model,
            guestlist: this.guestlist,
            store: this.store,
            back: this.state.current.name,
            backParams: this.params,
            tab: 'changelog'
        });
    }

    openRsvpInSeatplan() {
        this.state.go('app.guestlists.rsvps.seats', {gid: this.model.guestlist_id, rsvpId: this.model.id});
    }
}



// WEBPACK FOOTER //
// ./src/app/store/rsvps/controllers/extended-list-view.js